import React from 'react';

import classes from './TimeUnit.module.scss';

type TimeUnitProps = {
  value: string;
  label: string;
};

const TimeUnit = ({ value, label }: TimeUnitProps) => {
  return (
    <div className={classes.timeUnit}>
      <div className={classes.number}>{value}</div>
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export { TimeUnit };
